import React from 'react'
import PropTypes from 'prop-types'
import Icon from './Icon'

const Star = ({ fill, onClick, className, fillColor }) => {
  const style = fillColor ? {fill: fillColor} : {}
  return (
    <Icon onClick={onClick} className={className || 'star-icon'}>
      <svg viewBox='0 0 24 24'>
        <path
          className={!fillColor && `icon__fill ${fill || ''}`}
          fill={fillColor}
          d='M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z'
        />
      </svg>
    </Icon>
  )
}

Star.propTypes = {
  fill: PropTypes.string,
  fillColor: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string
}

export default Star
